import React from 'react';
// ⭐️ 분리된 자식 컴포넌트 import ⭐️
import InquiryCreateTable from '../component/InquiryCreateTable';
import InquiryImageModal from '../component/InquiryImageModal';
import * as apiUtil from "../../../util/apiUtil";
import {INQUIRY_CATEGORY_MAP} from "../store/inquiryConstants";

class InquiryCreateContainer extends React.Component {// 허용 파일 형식 정의
    ALLOWED_TYPES = [
        'image/jpeg', 'image/png', 'image/jpg', 'application/pdf',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' // .xlsx
    ];

    // 최대 허용 용량 (10MB)
    MAX_TOTAL_SIZE = 10 * 1024 * 1024;
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            inquiryType: '',
            title: '',
            content: '',

            attachedFiles: [],
            fileInputKey: Date.now(),

            showModal: false,
            modalFile: null,
        };


        this.setLoading = this.setLoading.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleFileChange = this.handleFileChange.bind(this);
        this.handleFileDelete = this.handleFileDelete.bind(this);
        this.closeFileModal = this.closeFileModal.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleFileClick = this.handleFileClick.bind(this);
    }

    setLoading(loading) {
        this.setState({ loading: loading });
    }

    // 인풋/셀렉트 값 변경 핸들러
    handleChange(e) {
        this.setState({ [e.target.name]: e.target.value });
    }

    // 파일 첨부 핸들러
    handleFileChange(e) {
        const newFiles = Array.from(e.target.files);
        const currentFiles = this.state.attachedFiles;

        // 1. 개수 제한 검사
        if (currentFiles.length + newFiles.length > 5) {
            alert("첨부파일은 최대 5개까지 등록 가능합니다.");
            this.setState({ fileInputKey: Date.now() });
            return;
        }

        // 2. 전체 용량 및 파일 형식 검사를 위한 데이터 준비
        let newTotalSize = currentFiles.reduce((sum, fileWrapper) => sum + fileWrapper.file.size, 0);

        let invalidFiles = [];
        let newFileList = [];

        newFiles.forEach(file => {
            // 2-1. 전체 용량 합산
            newTotalSize += file.size;

            // 2-2. 파일 형식 검증 (MIME Type 및 확장자 기반)
            const isTypeAllowed = this.ALLOWED_TYPES.includes(file.type);

            // Excel 파일의 경우 type이 정확하지 않을 수 있어, 확장자로 보강 검사
            const isExcelByExtension = file.name.toLowerCase().endsWith('.xls') || file.name.toLowerCase().endsWith('.xlsx');

            if (isTypeAllowed || isExcelByExtension) {
                // 유효한 파일 목록에 추가
                newFileList.push({
                    id: Date.now() + Math.random(),
                    name: file.name,
                    size: (file.size / 1024 / 1024).toFixed(2) + 'MB', // MB로 표시 단위 변경
                    file: file,
                    type: file.type,
                });
            } else {
                // 유효하지 않은 파일 목록 기록
                invalidFiles.push(file.name);
            }
        });

        // 3. 최종 전체 용량 제한 검사
        if (newTotalSize > this.MAX_TOTAL_SIZE) {
            alert(`첨부 가능한 전체 용량은 10MB 미만입니다.\n현재 등록하려는 파일 포함 총 용량: ${(newTotalSize / 1024 / 1024).toFixed(2)}MB`);
            this.setState({ fileInputKey: Date.now() });
            return;
        }

        // 4. 유효하지 않은 파일 경고
        if (invalidFiles.length > 0) {
            alert(`다음 파일은 지원되지 않는 형식입니다: ${invalidFiles.join(', ')}\n\n(허용 형식: JPG, JPEG, PNG, PDF, Excel)`);
        }

        // 5. 상태 업데이트
        this.setState(prevState => ({
            attachedFiles: [...prevState.attachedFiles, ...newFileList],
            fileInputKey: Date.now(),
        }));
    }

    // 파일 삭제 핸들러
    handleFileDelete(id) {
        this.setState(prevState => ({
            attachedFiles: prevState.attachedFiles.filter(file => file.id !== id),
        }));
    }

    // 모달 닫기 핸들러
    closeFileModal() {
        this.setState({ showModal: false, modalFile: null });
    }

    // 파일 클릭 시 타입별 동작을 처리하는 함수
    handleFileClick(file) {
        const { type, name, file: actualFile } = file;

        // 실제 File 객체에 대한 Blob URL 생성
        const url = URL.createObjectURL(actualFile);

        try {
            if (type && type.startsWith('image/')) {
                // Case 1: 이미지 -> 모달 열기 (기존 로직)
                this.setState({ showModal: true, modalFile: file });
                return;
            } else if (type && (type.includes('pdf'))) {
                window.open(url, '_blank');
            } else {
                const link = document.createElement('a');
                link.href = url;
                link.download = name;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        } catch (e) {
            console.error("파일 처리 오류:", e);
            alert("파일 처리에 실패했습니다. 브라우저 설정을 확인해주세요.");
        } finally {
            if (!(type && type.startsWith('image/'))) {
                URL.revokeObjectURL(url);
            }
        }
    }

    // 제출 핸들러
    handleSubmit() {
        const { inquiryType, title, content, attachedFiles, loading } = this.state;

        if (!inquiryType) { alert("문의 유형을 선택해주세요."); return; }
        if (!title) { alert("문의 제목을 입력해주세요."); return; }
        if (!content) { alert("문의 내용을 입력해주세요."); return; }

        if(loading) {
            return;
        }

        // 2. FormData 객체 생성
        let data = new FormData();

        // 텍스트 데이터 추가
        data.append('categoryUid', inquiryType);
        data.append('title', title);
        data.append('content', content);
        data.append('categoryName', INQUIRY_CATEGORY_MAP[inquiryType]);

        // 첨부 파일 목록 추가
        attachedFiles.forEach((fileWrapper) => {
            data.append("files", fileWrapper.file);
        });

        // 3. API 요청
        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: '/api/inquiry/create',
            method: apiUtil.requestMethod.POST,
            isFile: true,
            data: data,
            success: (result) => {
                alert('1:1 문의가 성공적으로 등록되었습니다.');
                window.location.href = '/announce/inquiry';
            },
        });
    }

    render() {
        const { inquiryType, title, content, attachedFiles, showModal, modalFile, fileInputKey } = this.state;

        return (
            <React.Fragment>
                <InquiryCreateTable
                    inquiryType={inquiryType}
                    title={title}
                    content={content}
                    attachedFiles={attachedFiles}
                    fileInputKey={fileInputKey}
                    handleChange={this.handleChange}
                    handleFileClick={this.handleFileClick}
                    handleFileChange={this.handleFileChange}
                    handleFileDelete={this.handleFileDelete}
                    handleSubmit={this.handleSubmit}
                />

                <InquiryImageModal
                    show={showModal}
                    file={modalFile}
                    onClose={this.closeFileModal}
                    showDownload={false}
                />
            </React.Fragment>
        );
    }
}

export default InquiryCreateContainer;